import { render, staticRenderFns } from "./InfoBeneficiario.vue?vue&type=template&id=01cdb6c1&scoped=true&"
import script from "./InfoBeneficiario.vue?vue&type=script&lang=js&"
export * from "./InfoBeneficiario.vue?vue&type=script&lang=js&"
import style0 from "./InfoBeneficiario.vue?vue&type=style&index=0&id=01cdb6c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cdb6c1",
  null
  
)

export default component.exports